import "lib/Date.extensions";
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import "typeface-roboto";
import { initI18n } from "./i18n";
import register, { unregister } from "./registerServiceWorker";
import Root from "./views/Root";

register();
//unregister();

initI18n(
    () => {
        ReactDOM.render(
            <Root />,
            document.getElementById('root') as HTMLElement
        );
    }
);

//if ('serviceWorker' in navigator) {
//    navigator.serviceWorker.getRegistrations().then(function (registrations) {

//        for (let registration of registrations) {
//            registration.unregister();
//            console.log('Service Worker registration unloaded');
//        }

//        init();
//    }).catch(function (err) {
//        console.log('Service Worker registration failed: ', err);
//    });
//}
//else
//    init();
